import React, { useState } from "react";
import { SearchList } from "./";
import { FaSearch, FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const IconsList = ({ icons, toggleIcon, setIcon }) => {
  const { t } = useTranslation();
  const [searchText, setsearchText] = useState("");

  const changeIcon = (icon) => {
    setIcon(icon);
    toggleIcon();
  };

  const filteredIcons = icons.filter((icon) => {
    return icon.caption.includes(searchText);
  });

  const searchIcon = (e) => {
    setsearchText(e.target.value);
  };

  return (
    <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
      <h2 className="setting-title">{t("انتخاب آیکون")}</h2>

      {/* Search Input - حفظ چیدمان قبلی */}
      <div className="inputs d-flex align-items-center text-muted w-100 px-3 mt-4" style={{ 
        background: "var(--bg-white)", 
        border: "2px solid var(--border-color)", 
        borderRadius: "16px", 
        padding: "12px 16px",
        gap: "10px"
      }}>
        <FaSearch style={{ color: "var(--primary-color)", fontSize: "18px" }} />
        <input
          type="text"
          placeholder={t("جستجوی آیکون")}
          onChange={searchIcon}
          name="caption"
          className="w-100 text-right fn mr-2"
          style={{
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: "14px",
            color: "var(--text-primary)"
          }}
        />
      </div>

      {/* Icons List - حفظ چیدمان flex-wrap */}
      <div className="d-flex justify-content-center flex-wrap mt-4">
        <SearchList filteredIcons={filteredIcons} changeIcon={changeIcon} />
      </div>

      {/* Back Button */}
      <div className="setting-buttons">
        <button
          type="button"
          className="setting-back-btn"
          onClick={toggleIcon}
          style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
        >
          <FaArrowLeft size={18} />
          <span>{t("بازگشت")}</span>
        </button>
      </div>
    </div>
  );
};

export { IconsList };